import React, { useState } from "react";
import axios from "axios";
import { login } from "../../../auth/auth";

const DEV_URL = process.env.REACT_APP_DEV_URL;

const EndpointTest = () => {
  const [chatHistory, setChatHistory] = useState([]);
  const [streamingText, setStreamingText] = useState("");
  const [userMessage, setUserMessage] = useState("");

  const handleStreamCallback = (streamData) => {
    console.log("Streaming text:", streamData.text);
    setStreamingText(streamData.text);
  };

  const Chatbot = async (
    app_id,
    passphrase,
    config_id,
    payload,
    stream_cb = undefined
  ) => {
    try {
      const formData = new FormData();
      formData.append("prompt", payload.prompt);
      formData.append("use_audio", "true");
      formData.append("use_expression", "true");
      formData.append("use_dall_e", "false");
      formData.append("activity", "chat");

      if (payload.scenario) {
        formData.append("scenario", payload.scenario.toString());
      }

      if (stream_cb) {
        formData.append("stream", "true");

        const url = `${DEV_URL}/api/chat/stream?app_id=${app_id}&passphrase=${passphrase}&config_id=${config_id}`;

        const authToken = await login();

        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
          body: formData,
        });

        if (!response.body) {
          throw new Error(
            "ReadableStream is not supported or response body is empty"
          );
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let accumulatedText = "";

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          let chunk = decoder.decode(value, { stream: true });
          console.log("Chunk received:", chunk);
          const lines = chunk.split("\n");

          for (const line of lines) {
            if (line.startsWith("data:")) {
              const textContent = line.substring(6);

              if (textContent.startsWith("[DONE]")) {
                const text = textContent.substring(7);
                const data = JSON.parse(text);
                return {
                  status: true,
                  message: data.message,
                  data: data.data,
                };
              }

              if (textContent === "") continue;

              accumulatedText += textContent;
              stream_cb({
                text: accumulatedText,
                sources: [],
                expression: { expression: "idle" },
                audio: null,
              });
            }
          }
        }

        return {
          status: false,
          message: "Failed streaming the response",
        };
      }
    } catch (error) {
      console.error("Error in Chatbot:", error);
      return {
        status: false,
        message: "An error occurred while processing the request",
      };
    }
  };

  const handleChatbotRequest = async () => {
    const app_id = "1";
    const passphrase = "$2b$12$q6Nvi.FWjg8JzS1PIPMEKe";
    const config_id = "1";

    const payload = {
      prompt: userMessage, // Use the user input as the prompt
      chat_history: chatHistory,
    };

    try {
      await Chatbot(
        app_id,
        passphrase,
        config_id,
        payload,
        handleStreamCallback
      );
      setUserMessage("");
    } catch (error) {
      console.error("Error in Chatbot request:", error);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#f0f0f0",
        padding: "20px",
        borderRadius: "8px",
      }}
    >
      <div>
        <input
          type="text"
          value={userMessage}
          onChange={(e) => setUserMessage(e.target.value)}
          placeholder="Type your message here..."
          style={{
            width: "80%",
            padding: "10px",
            marginBottom: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
        <button
          onClick={handleChatbotRequest}
          style={{
            padding: "10px 20px",
            marginLeft: "10px",
            backgroundColor: "#007BFF",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Send
        </button>
      </div>
      <div>
        <p>Streaming Text:</p>
        <p>{streamingText}</p>
      </div>
    </div>
  );
};

export default EndpointTest;
